import React from 'react';
import { PageLayout } from '@angeplus/prever-component-lib/nextjs';
import { ValidSessionRoute } from '@ferreri/minato-auth-react';
import { PAGE_TITLE } from 'utils/pageTitle';
import { PetAssistance } from 'modules/pet/PetAssistance';

export default function PetAssistancePage() {
  return (
    <ValidSessionRoute
      loadingComponent={
        <PageLayout title={PAGE_TITLE.assistance}>
          <PetAssistance />
        </PageLayout>
      }
    >
      <PageLayout title={PAGE_TITLE.assistance}>
        <PetAssistance />
      </PageLayout>
    </ValidSessionRoute>
  );
}
